import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {ValidationConstraint} from "../../domain/validation-constraint";
import {UtilService} from "../../services/util.service";
import * as _ from "lodash";

@Component({
    selector: 'app-base-select',
    templateUrl: './base-select.component.html'
})
export class BaseSelectComponent implements OnInit, OnChanges {
    @Input() placeholder: string;
    @Input() label: string;
    @Input() labelClass: string;
    @Input() elementId: string;
    @Input() disabled: boolean;
    @Input() required: boolean;
    @Input() tabIndex: number;
    @Input() styleClass: string;
    @Input() options: any[];
    @Input() display: string;
    @Input() value: string;
    @Input() minValue: number;
    @Input() maxValue: number;
    @Input() errors: object;
    @Input() modelPath: string;
    @Input() floatLabel: any;
    @Input() name: string;
    @Input() panelClass: string;
    @Input() compareWith: (o1: any, o2: any) => boolean;
    @Input() readonly: boolean;
    @Input() maxlength: number;
    @Input() validationConstraints: ValidationConstraint[];

    @Output() resultChange = new EventEmitter();

    @ViewChild('frm', {static: true}) form: any;
    public error: string;

    public fieldValidationConstraints: ValidationConstraint[];

    constructor(private cd: ChangeDetectorRef) {
        this.display = this.display || 'display';
        this.value = this.value || 'value';
        this.floatLabel = this.floatLabel || 'always';
        this.name = this.name || 'control';
        this.readonly = this.readonly || false;
    }

    ngOnInit(): void {
        this.error = UtilService.getObjByPath(this.errors, this.modelPath);
        if (this.error) {

            setTimeout(() => {
                if (this.form.form.controls[this.name]) {
                    this.form.form.controls[this.name].markAsTouched(true);
                    this.form.form.controls[this.name].setErrors({incorrect: true});
                    this.cd.detectChanges();
                }
            }, 500);
        }

        if (this.validationConstraints !== null && this.modelPath) {
            this.fieldValidationConstraints = _.filter(this.validationConstraints, ['field', this.modelPath]);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.errors !== undefined) {
            this.error = UtilService.getObjByPath(this.errors, this.modelPath);
            if (this.form.form.controls[this.name] && this.error) {
                this.form.form.controls[this.name].markAsTouched(true);
                this.form.form.controls[this.name].setErrors({backend: {someProp: 'some message'}});
            }
        }
        if (!this.error && this.form.form.controls[this.name]) {
            this.form.form.controls[this.name].markAsUntouched(true);
        }
    }

    getValue(option: any, path: string) {
        let val = option;
        if (path !== '' && val) {
            const dp = path.split('.');
            for (let i = 0; i < dp.length; i++) {
                val = val[dp[i]];
            }
        }
        return val;
    }
}
